
angular
	.module('servicepro.common', []);